const initialState = {
    products: [],
};

const flashSale = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_FLASH_SALE':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default flashSale;
